let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gTMPL")).then(() => parcelRequire('9BQbx'));